import { IUnitData } from "@/services/project/modal"
import classNames from "classnames"
import { EUnitStatus } from "./types"
import { getUnitStatus, getUnitStatusClassName } from "./utils"
import { ExceptionOutlined } from "@ant-design/icons"
import Dialog from "@/libs/dialog"
import { useState } from "react"

interface UnitImageProps {
  svg: string
  data?: IUnitData
  height: number
}

export function UnitImageWithStatus(props: UnitImageProps) {
  const {svg, data, height} = props
  const [show, setShow] = useState(false)

  const status = getUnitStatus(data)
  const statusClassName = getUnitStatusClassName(status)

  return <>
    <div className="flex-center unit-image">
      <div dangerouslySetInnerHTML={{__html: svg}} style={{height: height}} className={classNames(statusClassName)}></div>
    </div>
    {[EUnitStatus.Warning, EUnitStatus.Error].includes(status) && <div className={classNames("unit-message text-center", statusClassName)}>
      <span>{data?.message}</span>
      {data?.msgDetail && <span className="ml-2" style={{cursor: 'pointer'}} onClick={() => setShow(true)}><ExceptionOutlined /></span>}
    </div>}
    {show && <Dialog title="Error Detail" visible={true} footer={null} onClose={() => setShow(false)}>
      <pre>
        {data?.msgDetail}
      </pre>
    </Dialog>}
  </>
}